module.exports = __webpack_public_path__ + "img/ay11Image.247822b0.png";